import {fetchJSONByGet, fetchJSONByPost} from './index.js'

// 获取列表
export const fetchRecordsApi = (params, trigger = false) => fetchJSONByGet('/adms_api_v0/product/publish/records', params, {trigger})
// 重新发布
export const rePublishApi = (body, batch = false) => fetchJSONByPost(`/adms_api_v0/product/rePublish${batch ? '/batch' : ''}`, body)
// 预览重新发布
export const rePreviewAndPublishApi = (body, batch = false) => fetchJSONByPost(`/adms_api_v0/product/rePreviewAndPublish${batch ? '/batch' : ''}`, body)

